/* eslint-disable react-hooks/exhaustive-deps */
import { FC, useContext, useState, useEffect, useMemo } from 'react'
import { useQuery } from 'react-query'
import {
    createResponseContext,
    initialQueryResponse,
    WithChildren,
} from '../../../../../../../general/helpers'
import { get_payment_scheme_query } from '../../../../core/_request'
import { prepareQueryString } from '../../../../core/helper'
import { PaymentSchemesResponse } from '../../../../core/_models'
import { usePaymentSchemesQueryRequest } from './PaymentSchemesRequestProvider'

const QueryResponseContext = createResponseContext<PaymentSchemesResponse>(initialQueryResponse)
const PaymentSchemesQueryResponseProvider: FC<WithChildren> = ({ children }) => {
    const { state, loading, toggleLoading } = usePaymentSchemesQueryRequest()

    // Use prepareQueryString instead of extractQueryParams to match legacy style and include '?'
    const [query, setQuery] = useState<string>(prepareQueryString({ ...state, page: (state.page || 1) - 1 }))
    const updatedQuery = useMemo(() => prepareQueryString({ ...state, page: (state.page || 1) - 1 }), [state])

    useEffect(() => {
        if (query !== updatedQuery) {
            setQuery(updatedQuery)
        }
    }, [updatedQuery])

    const {
        isFetching,
        refetch,
        data: response,
    } = useQuery(
        `payment-schemes-list-${query}`,
        () => {
            return get_payment_scheme_query(localStorage.getItem('kt-auth-react-v') ? JSON.parse(localStorage.getItem('kt-auth-react-v') || '{}')?.accessToken : '', query)
        },
        {
            cacheTime: 0,
            keepPreviousData: true,
            refetchOnWindowFocus: false,
            onSettled: () => {
                loading && toggleLoading?.()
            },
            retry: false,
        }
    )

    return (
        <QueryResponseContext.Provider value={{ isLoading: isFetching, refetch, response, query }}>
            {children}
        </QueryResponseContext.Provider>
    )
}

const usePaymentSchemesQueryResponse = () => useContext(QueryResponseContext)

const usePaymentSchemesQueryResponseData = () => {
    const { response } = usePaymentSchemesQueryResponse()
    if (!response) {
        return []
    }

    return response.paymentSchemes || []
}

const usePaymentSchemesQueryResponseLoading = (): boolean => {
    const { isLoading } = usePaymentSchemesQueryResponse()
    return isLoading
}

const usePaymentSchemesQueryResponseTotalCount = (): number => {
    const { response } = usePaymentSchemesQueryResponse()
    return response?.totalCounts ?? 0
}

export {
    PaymentSchemesQueryResponseProvider,
    usePaymentSchemesQueryResponse,
    usePaymentSchemesQueryResponseData,
    usePaymentSchemesQueryResponseLoading,
    usePaymentSchemesQueryResponseTotalCount,
}
